import {
  BarChart3,
  CreditCard,
  FileText,
  Home,
  Megaphone,
  Settings,
  Tag,
  User,
  Users,
} from 'lucide-react';
import type { NavSection } from './Sidebar.types';

export const getNavSections = (): NavSection[] => {
  const basePath = '';

  return [
    {
      title: '',
      items: [
        {
          icon: Home,
          label: 'Dashboard',
          path: `${basePath}/dashboard`,
        },
      ],
    },
    {
      title: 'Content',
      items: [
        {
          icon: Tag,
          label: 'Brands',
          path: `${basePath}/brands`,
        },
        {
          icon: FileText,
          label: 'Articles',
          path: `${basePath}/articles`,
        },
      ],
    },
    {
      title: 'Marketing',
      items: [
        {
          icon: Megaphone,
          label: 'Advertorials',
          path: `${basePath}/advertorials`,
        },
        {
          icon: Users,
          label: 'Leads',
          path: `${basePath}/leads`,
        },
        {
          icon: BarChart3,
          label: 'Reports',
          path: `${basePath}/reports`,
        },
      ],
    },
    {
      title: 'Account',
      items: [
        {
          icon: CreditCard,
          label: 'Subscription',
          path: `${basePath}/subscription`,
        },
        {
          icon: User,
          label: 'Supplier Profile',
          path: `${basePath}/supplier-profile`,
        },
        {
          icon: Settings,
          label: 'Settings',
          path: `${basePath}/settings`,
        },
      ],
    },
  ];
};
